module.exports = __webpack_public_path__ + "img/kuaiya.c5534f63.png";